import styled from "styled-components"

export const ListStarWrapper = styled.div`
    .list_star{
    display: flex;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;
    &_item{
        &_icon{
            font-size: 0.8rem;
            color: #e19292;
            &-active{
                color: #ff6801;
            }
        }
    }
}
`